import React from 'react';

import RufsError from '../errors/rufsError.jsx';

const SuggestDiscountError = () => (
    <RufsError>
        Vi kan ikke sende forslaget til avslag akkurat nå. Prøv igjen om litt.
    </RufsError>
);

export default SuggestDiscountError;



// WEBPACK FOOTER //
// ./safeTrade/resolution/suggestDiscountError.jsx